interface S3ObjectLocationProps {
  bucketName: string;
  fileName: string;

  region: string;
}

export function S3ObjectLocation({
  bucketName,
  fileName,
  region,
}: S3ObjectLocationProps) {
  if (bucketName && fileName && region) {
    // Use encodeURIComponent to ensure the fileName is URL-safe
    const encodedFileName = encodeURIComponent(fileName);
    const location = `https://${bucketName}.s3.${region}.amazonaws.com/${encodedFileName}`;
    return location;
  }
  return "Issue with the Location path generator";
}
